/**
 * Stammdaten für Impressum und Datenschutzerklärung.
 *
 * MatchGate ist ein Produkt von NxGn Media. Betreiberin und rechtlich
 * verantwortlich ist die Reitzig & Stöhr GbR - die Angaben stammen aus dem
 * Impressum der NxGn-Website und sind mit dieser abgeglichen.
 *
 * Mit "TODO" beginnende Werte sind noch offen und werden auf der Seite
 * sichtbar als Platzhalter ausgezeichnet.
 */
export const COMPANY = {
  name: "Reitzig & Stöhr GbR - NxGn Media",
  representedBy: "Die Gesellschafter Alexander Reitzig und Leon Stöhr",
  street: "Heinrichstraße 17",
  postalCode: "45711",
  city: "Datteln",
  country: "Deutschland",
  // § 18 Abs. 2 MStV - natürliche Person mit vollständiger Anschrift
  editorialResponsible: {
    name: "Alexander Reitzig",
    street: "Heinrichstraße 17",
    city: "45711 Datteln",
  },
};

/**
 * Eine GbR ist nicht im Handelsregister eingetragen, deshalb entfällt der
 * Registerabschnitt. Solange keine USt-IdNr. nach § 27a UStG vergeben ist,
 * entfällt auch dieser Abschnitt - die Steuernummer gehört ausdrücklich
 * NICHT ins Impressum. Auf true setzen, sobald eine USt-IdNr. vorliegt.
 */
export const HAS_VAT_ID = false;
export const VAT_ID = "";

/** Zuständig ist die Behörde am Sitz der Gesellschaft (Datteln, NRW). */
export const SUPERVISORY_AUTHORITY =
  "die Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen, Kavalleriestraße 2-4, 40213 Düsseldorf";

/**
 * MatchGate wird wie die NxGn-Website bei STRATO gehostet (Server in
 * Deutschland). Die Vereinbarung zur Auftragsverarbeitung nach Art. 28 DSGVO
 * wurde laut Kunden-Login am 28.03.2026 abgeschlossen.
 */
export const HOSTING_PROVIDER =
  "STRATO AG, Otto-Ostrowski-Straße 7, 10249 Berlin";

/** Löschfrist der Server-Logfiles, analog zur NxGn-Website. */
export const LOGFILE_RETENTION = "30 Tagen";

/** Stand der Rechtstexte. Bei jeder inhaltlichen Änderung mitziehen. */
export const LEGAL_UPDATED = "Oktober 2026";

/**
 * Blendet auf allen Rechtstexten den Hinweis „Entwurf, noch nicht rechtlich
 * geprüft“ ein. Seit 18.10.2026 aus, damit die Seiten veröffentlicht werden
 * können; die anwaltliche Prüfung folgt (RECHTLICHES.md). Die AGB tragen
 * stattdessen einen eigenen Hinweis (`notice` in LegalPage).
 */
export const LEGAL_IS_DRAFT = false;
